module.exports = __webpack_public_path__ + "static/media/OAcquiring-logo-white.d2473b5f.png";